"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneratedPodcastStageStatus = exports.GeneratedArtifactType = exports.StreamAIEventType = void 0;
var StreamAIEventType;
(function (StreamAIEventType) {
    StreamAIEventType["MESSAGE_CHUNK"] = "message_chunk";
    StreamAIEventType["DONE"] = "done";
    StreamAIEventType["ERROR"] = "error";
    StreamAIEventType["METADATA"] = "metadata";
    StreamAIEventType["TITLE_UPDATE"] = "title_update";
    StreamAIEventType["MESSAGE_METADATA"] = "message_metadata";
    StreamAIEventType["DOCUMENT_START"] = "document_start";
    StreamAIEventType["DOCUMENT_TITLE"] = "document_title";
    StreamAIEventType["DOCUMENT_CHUNK"] = "document_chunk";
    StreamAIEventType["DOCUMENT_END"] = "document_end";
    StreamAIEventType["DOCUMENT_METADATA"] = "document_metadata";
    StreamAIEventType["DOCUMENT_ERROR"] = "document_error";
    StreamAIEventType["TOOL_USE_GENERATION_START"] = "tool_use_generation_start";
    StreamAIEventType["TOOL_USE_GENERATION_END"] = "tool_use_generation_end";
    StreamAIEventType["TOOL_USE_EXECUTION_START"] = "tool_use_execution_start";
    StreamAIEventType["TOOL_USE_EXECUTION_END"] = "tool_use_execution_end";
})(StreamAIEventType || (exports.StreamAIEventType = StreamAIEventType = {}));
var GeneratedArtifactType;
(function (GeneratedArtifactType) {
    GeneratedArtifactType["DOCUMENT"] = "document";
    GeneratedArtifactType["IMAGE"] = "image";
    GeneratedArtifactType["PODCAST"] = "podcast";
})(GeneratedArtifactType || (exports.GeneratedArtifactType = GeneratedArtifactType = {}));
var GeneratedPodcastStageStatus;
(function (GeneratedPodcastStageStatus) {
    GeneratedPodcastStageStatus["LOADING"] = "loading";
    GeneratedPodcastStageStatus["READY"] = "ready";
    GeneratedPodcastStageStatus["ERROR"] = "error";
})(GeneratedPodcastStageStatus || (exports.GeneratedPodcastStageStatus = GeneratedPodcastStageStatus = {}));
